import React from 'react';
import { ThemeProvider } from '@friendsofreactjs/react-css-themr';
import webIds from 'components/identifiers';
import _ from 'lodash';

const getDefaultThemes = () => ({
  /* eslint-disable global-require */
  [webIds.Auth.Shared]: require('themes/AuthShared.module.scss'), // NOTE: Auth.Shared must be before all other Auth files
  [webIds.App]: require('themes/styleguide/redesign/v2/App.css'),
  [webIds.HeaderImageTitle]: require('components/HomeImageHeader/HomeImageHeader.css'),
  [webIds.Live.Dropdown]: require('screens/Live/styles/Dropdown.css'),
  [webIds.Live
    .DropdownPrimetime]: require('screens/Live/components/PrimeTimeGrid/DropdownPrimetime.css'),
  [webIds.ContentDetail.VideosTab
    .VideoTile]: require('screens/ContentDetail/components/VideosTab/styles/videoTiles.css'),
  [webIds.StringList]: require('themes/StringList.css'),
});

const getNationThemes = () => ({
  ...getDefaultThemes(),
  [webIds.App]: require('themes/styleguide/nation/App.css'),
  [webIds.Auth.Shared]: require('themes/styleguide/nation/Auth/Shared.module.scss'), // NOTE: Auth.Shared must be before all other Auth files
  [webIds.Live.Dropdown]: require('themes/styleguide/nation/Live/Dropdown.css'),
});

const getStyleguideThemes = () => getNationThemes();

const wrapComponentsWithStyleguideThemeProvider = components => {
  const styleguideThemes = getStyleguideThemes();
  return <ThemeProvider theme={styleguideThemes}>{components}</ThemeProvider>;
};

export const wrapComponentsWithThemeProvider = components =>
  wrapComponentsWithStyleguideThemeProvider(components);
export const getTheme = id => _.get(getStyleguideThemes(), id);
export const webThemeIds = webIds;

const addClassesToElement = (classesToAdd, element) => {
  const isValidArray = Array.isArray(classesToAdd);
  const isObject = element && typeof element.classList === 'object';
  const hasAddClass = isObject && typeof element.classList.add === 'function';

  if (!hasAddClass || !isValidArray) return;

  classesToAdd.map(theClass => {
    if (!theClass) return null;
    element.classList.add(theClass);
    return null;
  });
};

const removeClassesFromElement = (classesToRemove, element) => {
  const isValidArray = Array.isArray(classesToRemove);
  const isObject = element && typeof element.classList === 'object';
  const hasRemoveClass = isObject && typeof element.classList.remove === 'function';

  if (!hasRemoveClass || !isValidArray) return;

  classesToRemove.map(theClass => {
    if (!theClass) return null;
    element.classList.remove(theClass);
    return null;
  });
};

export const addBodyClass = classesToAdd => {
  if (!document || !document.body) return;
  addClassesToElement(classesToAdd, document.body);
};

export const removeBodyClass = classesToAdd => {
  if (!document || !document.body) return;
  removeClassesFromElement(classesToAdd, document.body);
};
export const addHTMLClass = classesToAdd => {
  const hasElement = document && document.getElementsByTagName('html')[0];
  if (!hasElement) return;
  const element = document.getElementsByTagName('html')[0];
  addClassesToElement(classesToAdd, element);
};

export const removeHTMLClass = classesToAdd => {
  const hasElement = document && document.getElementsByTagName('html')[0];
  if (!hasElement) return;
  const element = document.getElementsByTagName('html')[0];
  removeClassesFromElement(classesToAdd, element);
};

export const isElementExist = id => {
  const element = document.getElementById(id);
  return typeof element !== 'undefined' && element !== null;
};
